import { render, staticRenderFns } from "./consultation-frequency.vue?vue&type=template&id=a045ba14&scoped=true&"
import script from "./consultation-frequency.vue?vue&type=script&lang=js&"
export * from "./consultation-frequency.vue?vue&type=script&lang=js&"
import style0 from "./consultation-frequency.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./consultation-frequency.vue?vue&type=style&index=1&id=a045ba14&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a045ba14",
  null
  
)

export default component.exports